var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 23.5H21.875V21.3889H26.125M26.125 27.7222H21.875V25.6111H26.125M32.5 19.2778H29.5144C29.0351 18.4521 28.3741 17.7448 27.5806 17.2089L29.3125 15.4883L27.8144 14L25.5087 16.2906C24.5208 16.0524 23.4898 16.0524 22.5019 16.2906L20.1856 14L18.6875 15.4883L20.4088 17.2089C19.6225 17.7472 18.9637 18.4544 18.4856 19.2778H15.5V21.3889H17.7206C17.6675 21.7372 17.625 22.0856 17.625 22.4444V23.5H15.5V25.6111H17.625V26.6667C17.625 27.0256 17.6675 27.3739 17.7206 27.7222H15.5V29.8333H18.4856C19.5906 31.7228 21.6413 33 24 33C26.3588 33 28.4094 31.7228 29.5144 29.8333H32.5V27.7222H30.2794C30.3325 27.3739 30.375 27.0256 30.375 26.6667V25.6111H32.5V23.5H30.375V22.4444C30.375 22.0856 30.3325 21.7372 30.2794 21.3889H32.5V19.2778Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconBug);
export default __webpack_public_path__ + "static/media/menu-icon-bug.4c18c62c349c976b5b1fae5b876bffa4.svg";
export { ForwardRef as ReactComponent };